
import React, {FC, useState} from 'react';
import classNames from 'classnames';
import Button from 'components/Button';
import {Feedback as FB} from 'components/ContentPagesComponents/VoiceAgent/_VoiceControl/reducer';

import {Question} from './Question/Question';
import {Thumbs} from './Thumbs';
import {pickQuestions} from './useQuestions';

import * as styles from './styles.module.scss';

type FeedbackProps = {
	onFeedback: (feedback: FB, final: boolean) => void
}

export const Feedback: FC<FeedbackProps> = ({onFeedback}) => {
	const [state, setState] = useState<FB>(() => {
		return {
			stars: pickQuestions().map((question) => ({
				question, stars: 0,
			})),
		};
	});

	if (!state.thumbs) {
		return (
			<div className={classNames(styles.feedback, styles.thumbs)}>
				<h1>Was this call helpful?</h1>
				<Thumbs onThumbs={(thumbs) => {
					const feedback: FB = {
						...state,
						thumbs,
					};

					setState(feedback);
					onFeedback(feedback, false);
				}} />
				<p>
					Your feedback helps us
					improve our consultations.
				</p>
			</div>
		);
	}

	const onStars = (index: number, rating: number) => {
		if (state.stars[index].stars === rating && rating === 1) {
			rating = 0;
		}

		const feedback: FB = {
			...state,
			stars: state.stars.map(
				(s, i) => i !== index ? s : {
					...s,
					stars: rating,
				},
			),
		};

		setState(feedback);
		onFeedback(feedback, false);
	};

	const filled: boolean = state.stars.reduce(
		(acc, curr) => acc && curr.stars > 0, true,
	);

	return (
		<div className={classNames(styles.feedback, styles.stars)}>
			<h2>How did we do?</h2>
			{state.stars.map(({question, stars}, index) => (
				<Question
					key={index}
					index={index}
					question={question}
					rating={stars}
					onStars={onStars}
				/>
			))}
			<Button
				disabled={!filled}
				variant='light'
				onClick={() => onFeedback(state, true)}
			>
				Share feedback
			</Button>
		</div>
	);
};
